/**
 * Safely parse JSON; returns fallback if malformed/empty.
 * @param {any} src
 * @param {any} fallback
 * @returns {any}
 */
export const safeParseJSON = (src, fallback) => {
    if (Array.isArray(src) || (src && typeof src === 'object')) return src || fallback;
    if (typeof src !== 'string' || src.trim() === '') return fallback;
    try {
      return JSON.parse(src);
    } catch {
      return fallback;
    }
  };
  
  /**
   * Parse to array safely; never throws.
   * @param {any} src
   * @param {Array} fallback
   * @returns {Array}
   */
  export const parseArraySafely = (src, fallback = []) => {
    const parsed = safeParseJSON(src, fallback);
    return Array.isArray(parsed) ? parsed : fallback;
  };